<template>
  <div class="callback">{{message}}</div>
</template>

<script>

import hash from 'hash-parse';

export default {
  name: 'callback',
  data() {
    return {
      message: 'Loading..'
    }
  },
  mounted() {
    console.log("handling auth");
    console.log(this.$route);
    var result = hash.parse(this.$route.hash);
    if (result.error) {
      this.message = decodeURI(result.error_description) + "   This page will automatically redirect to the login page in 5 seconds";
      setTimeout(() => {
        this.$auth.handleAuthentication().then((data) => {
          this.$router.push({ name: 'Dashboard' })
        })
      }, 5000);
    } else {
      this.$auth.handleAuthentication().then((data) => {
        this.$router.push({ name: 'Dashboard' })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// Callback.vue?1fca6266